export default __webpack_public_path__ + "static/media/responsive.9a954166.svg";